import axios from "./axios";
import * as c from "./config";

export const Login = ({ email, password }) =>
  new Promise((resolve, reject) => {
    if (email && password) {
      axios
        .post(c.LOGIN, { email, password })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    }
  });

export const GetUser = (id, token, page = 1, limit = 10) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.USERINFO}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const GetTransfers = (id, token, page = 1, limit = 10) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.LISTTRANSFERS}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const GetRecharges = (id, token, page = 1, limit = 10) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.LISTRECHARGES}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const GetInvoices = (id, token, page = 1, limit = 10) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.LISTINVOICES}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const GetListSimulations = (token, page = 1, limit = 10, agentId) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.LISTSIMULATIONS}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
          agentId,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const GetListeLiveSupAgent = (token, page = 1, limit = 10) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.LISTLIVESUPAGENT}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const GetListeAgent = (token) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETLISTEAGENT}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

// export const AssignAgent = (clientId, agentAssignedId, token) =>
// new Promise((resolve, reject) => {
//   axios
//     .post(`${c.ASSIGNAGENT}`, {
//         headers: {
//         Authorization: `Bearer ${token}`,
//       },

//     })
//     .then((response) => resolve(response.data))
//     .catch((err) => reject(err))
// })

export const AssignAgent = async (clientId, agentAssignedId, token) => {
  const response = await axios.post(
    c.ASSIGNAGENT,
    {
      clientId,
      agentAssignedId,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const GetListSimulationsSupAgent = (token, page = 1, limit = 10) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.LISTSIMULATIONSSUPAGENT}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const AddNote = (body, token) =>
  new Promise((resolve, reject) => {
    axios
      .post(c.ADDNOTE, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const GetCalledClients = (
  token,
  id,
  startDate,
  endDate,
  page = 1,
  limit = 10
) =>
  new Promise((resolve, reject) => {
    axios
      .get(`/call/${id}/called-clients`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startDate,
          endDate,
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
export const GetAllClients = (
  token,
  startDate,
  endDate,
  page = 1,
  limit = 10
) =>
  new Promise((resolve, reject) => {
    axios
      .get(`/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startDate,
          endDate,
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const Stats = (token) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETLISTESTATS}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const ListeTransfertCashPickup = (token, page = 1, limit = 10) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETLISTETRANSFERTCASH}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const ListeTransfertBankAccount = (token, page = 1, limit = 10) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETLISTETRANSFERTBANKACCOUNT}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const ListeRecharge = (token, page = 1, limit = 10) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETLISTERECHARGE}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const ListeInvoice = (token, page = 1, limit = 10) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETLISTEINVOICE}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

// marketing

export const CreateBlogAPI = async (data) => {
  try {
    const response = await axios.post(`${c.CREATEBLOG}`, data, {
      // headers: {
      //   Authorization: `Bearer ${token}`,
      //   "Content-Type": "multipart/form-data",
      // },
    });

    return response.data;
  } catch (err) {
    // Throws the error up so your component's try/catch block can handle it
    throw err;
  }
};

export const CreateContentFAQ = async (data, id) => {
  try {
    const response = await axios.put(`${c.CREATECONTENTFAQ}/${id}/contentfaq`, data, {
      // headers: {
      //   Authorization: `Bearer ${token}`,
      //   "Content-Type": "multipart/form-data",
      // },
    });

    return response.data;
  } catch (err) {
    // Throws the error up so your component's try/catch block can handle it
    throw err;
  }
};

export const UploadImageArticle = async (data, id) => {
  try {
    const response = await axios.post(`${c.CREATEIMAGEARTICLE}/${id}/images`, data);

    return response.data;
  } catch (err) {
    throw err;
  }
};

export const GetListeBlogs = (page , limit) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETLISTBLOGS}`, {
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const GetAllTypes = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETALLTYPPES}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const GetBlogByIdAPI = (id) =>
  new Promise((resolve, reject) => {
    axios
      .get(`/blogs/id/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

  export const UpdateBlogAPI = async (id, data) =>
  new Promise((resolve, reject) => {
    axios
      .put(`/blogs/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });


  export const GetListeGame = (page , limit) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETLISTGAME}`, {
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

  export const GetUserGameDetails = ( id) =>
  new Promise((resolve, reject) => {
    axios
      .get(`/userGiftGame/users/${id}/gifts-games`, {
      id
        
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

  
export const NotificationPush = async (token, page, limit) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.CREATEBLOG}`, {
        params: { page, limit },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
